module.exports = {"helmetTitle":"Veloe - Criar nova senha","title":"Criar nova senha","subtitle":"Agora é só você pensar numa senha nova para acessar a Veloe. E lembre-se: ela deve ter seis caracteres e pelo menos uma letra e um número.","modalTitle":"Pronto! A gente já salvou suas alterações. ;)"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/CreateNewPassword/data.json
// module id = 2127
// module chunks = 0